import { TheWestSection } from '@news-mono/common'
import {
    ArticleAvailableEvent,
    EntitledToView,
    PublicationEvents,
    PublicationType,
    RequiredAccess,
    useToggleState,
} from '@news-mono/web-common'
import H from 'history'
import React from 'react'
import { Logger } from 'typescript-log'
import { useSection } from '../..'
import {
    BreachNotificationWrapper,
    BreachWallContentType,
    useBreachWallConfig,
} from './components/BreachNotificationWrapper/BreachNotificationWrapper'
import { checkIsRegional } from './components/SubscriptionPackage/SubscriptionPackage'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import { StyledFeatureArticleBreachNotification } from './FeatureArticleBreach.styled'

export interface FeatureArticleBreachProps {
    requiredAccess: RequiredAccess
    location: H.Location
    commonElements: React.ReactElement<any>
    comments?: React.ReactElement<any>
    onEvent: (event: ArticleAvailableEvent | PublicationEvents) => void
    article: PublicationType
    log: Logger
}

export const FeatureArticleBreach: React.FC<FeatureArticleBreachProps> = (
    props,
) => {
    const {
        commonElements,
        comments,
        requiredAccess,
        location,
        onEvent,
        article,
        log,
    } = props

    const { creativeName, deal, type } = useBreachWallConfig(location)

    const section = useSection<TheWestSection>()

    const isRegional = checkIsRegional(section)

    // ABTEST : Configure the breach deals here to override all breach deals
    //AB Test parameters
    const abTestVariation = useToggleState()?.['breach-ab-test-1'] || 'a'

    let abBreachDeal: string | undefined
    let abBreachType: BreachWallContentType

    if (abTestVariation && !isRegional) {
        if (abTestVariation === 'a') {
            abBreachDeal = deal
            abBreachType = type
        }
        if (abTestVariation === 'b') {
            abBreachDeal = 'DIG1X4'
            abBreachType = 'abtest-b-1x4'
        }
        if (abTestVariation === 'c') {
            abBreachDeal = 'DIG50CX8'
            abBreachType = 'abtest-c-50cx8'
        }
        if (abTestVariation === 'd') {
            abBreachDeal = 'DIG50X8'
            abBreachType = 'abtest-d-50px8'
        }
    }

    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={article.slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                creativeName,
                abBreachDeal ? abBreachDeal : deal,
                location,
                onEvent,
                article,
            )}
            entitled={() => {
                return (
                    <div>
                        {commonElements}
                        {props.children}
                        {comments}
                    </div>
                )
            }}
            notEntitled={() => {
                return (
                    <div>
                        {commonElements}
                        <StyledFeatureArticleBreachNotification>
                            <BreachNotificationWrapper
                                publication={article}
                                requiredAccess={requiredAccess}
                                breachDeal={abBreachDeal ? abBreachDeal : deal}
                                breachCreativeName={creativeName}
                                onEvent={onEvent}
                                type={abBreachType ? abBreachType : type}
                                blocks={[]}
                                log={log}
                            />
                        </StyledFeatureArticleBreachNotification>
                        {comments}
                    </div>
                )
            }}
        />
    )
}

FeatureArticleBreach.displayName = 'FeatureArticleBreach'
